import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row-actions" }

import { request } from '@/admin/shared/api/httpClient';


export default /*@__PURE__*/_defineComponent({
  __name: 'BookingActions',
  props: {
    detail: {}
  },
  setup(__props: any) {

const props = __props;

async function cancelBooking(): Promise<void> {
    const reason = prompt('Причина отмены:');
    if (!reason) return;
    await request({
        method: 'post',
        url: `/admin-api/bookings/${props.detail.id}/cancel/`,
        data: { reason },
    });
    window.location.reload();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "btn btn--danger",
      onClick: cancelBooking
    }, "Отменить бронирование")
  ]))
}
}

})